/**
 * Every Invoice.payment_method value, with the label the invoice shows for it.
 *
 * Mirrors Invoice.PAYMENT_METHOD_CHOICES (invoicing/models.py). The invoice list's payment
 * method filter and the invoice view both read this list, so a method added on the backend
 * has to be added here too: ./test.sh tests.test_payment_methods_guard fails until it is.
 */
export const PAYMENT_METHODS = [
  { value: 'bank_transfer', labelKey: 'Bank transfer' },
  { value: 'card', labelKey: 'Card payment' },
  { value: 'cash', labelKey: 'Cash payment' },
  { value: 'financing', labelKey: 'financingPayment' },
  { value: 'refund_bank', labelKey: 'invoices.refundBankMethod' },
  { value: 'invoiced_elsewhere', labelKey: 'invoices.invoicedElsewhereMethod' },
];

/** The translated label of a payment method, or the raw value for one this list does not know. */
export const paymentMethodLabel = (t, value) => {
  const method = PAYMENT_METHODS.find((m) => m.value === value);
  return method ? t(method.labelKey) : value;
};
